<template>
  <mf-tooltip v-if="variant === 'potential'" :disabled="!showInconclusiveTooltip || value > 0" max-width="320" top variant="secondary">
    <template v-slot:activator>
      <div class="potential-stonks">
        <div v-if="showIcon" class="icon-container icon-margin">
          <mf-icon icon="trending_up" size="16" color="branco" />
        </div>
        <span v-if="value && value > 0" class="value">R$ {{ value | localeString(0) }}</span>
        <span v-else-if="potentialText" class="value potential-text">Ganho potencial</span>
        <span v-else class="value">Inconclusivo</span>
      </div>
    </template>
    Pelo faturamento atual desse produto não é possível estimar um valor de Ganho potencial.
  </mf-tooltip>

  <div v-else class="percentage-container" :class="`percentage-stonks-${iconColor}`">
    <span v-if="showValue" class="value">R$ {{ showBlur ? 'XX.XX' : value | localeString(0) }}</span>
    <div v-if="showIcon" class="icon-container" :class="showText ? 'icon-r-margin' : 'icon-x-margin'">
      <mf-icon :icon="iconVariant" size="16" color="branco" />
    </div>
    <span v-if="showText" class="value percentage-text">{{ percentageText }}</span>
    <span v-if="!showOnlyIcon" class="value percentage" :class="bold || showText ? 'set-weight' : ''"
      >{{ percentage >= 0 ? '+' : '' }}{{ showBlur ? 'XX.XX' : percentage | localeString(hidePercentageDecimal ? 0 : 1) }}%</span
    >
  </div>
</template>

<script>
export default {
  name: 'MfStonks',
  props: {
    variant: {
      type: String,
      required: true,
      validator: (value) => ['potential', 'percentage'].includes(value),
    },
    value: {
      type: Number,
      default: 0,
    },
    percentage: {
      type: Number,
      default: 0,
    },
    hidePercentageDecimal: {
      type: Boolean,
      default: false,
    },
    showValue: {
      type: Boolean,
      default: false,
    },
    potentialText: {
      type: Boolean,
      default: false,
    },
    showText: {
      type: Boolean,
      default: false,
    },
    percentageText: {
      type: String,
      default: '',
    },
    showInconclusiveTooltip: {
      type: Boolean,
      default: false,
    },
    showIcon: {
      type: Boolean,
      default: true,
    },
    showBlur: {
      type: Boolean,
      default: false,
    },
    showOnlyIcon: {
      type: Boolean,
      default: false,
    },
    bold: {
      type: Boolean,
      default: false,
    },
    reversed: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    iconColor() {
      const evaluationValue = this.reversed ? -this.percentage : this.percentage
      if (evaluationValue < 1 && evaluationValue > -1) return 'neutral'
      else if (evaluationValue >= 1) return 'positive'
      else return 'negative'
    },
    iconVariant() {
      if (this.percentage < 1 && this.percentage > -1) return 'remove'
      else if (this.percentage >= 1) return 'arrow_upward'
      else return 'arrow_downward'
    },
  },
}
</script>

<style lang="scss" scoped>
.percentage-container {
  display: flex;
  flex-direction: row;
  align-items: center;
}

.potential-stonks {
  display: flex;
  flex-direction: row;
  align-items: center;
  .icon-container {
    background: $verde-l10;
  }
}
.icon-container {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 22px;
  height: 22px;
  border-radius: 4px;
  position: relative;

  .icon-wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 100%;
    margin: 0;
    padding: 0;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }

  .mf-icon {
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 0;
    padding: 0;
    text-align: center;
  }
}
.icon-margin {
  margin-right: 8px !important;
}
.icon-r-margin {
  margin-right: 8px !important;
}
.icon-x-margin {
  margin: 0 8px !important;
}
.value {
  color: $cinza-0;
  font-size: 14px;
}
.potential-text {
  color: $cinza-d10;
}
.percentage-stonks-neutral {
  .icon-container {
    background: $cinza-0;
  }
}
.percentage-stonks-positive {
  .icon-container {
    background: $verde-0;
  }
  .percentage {
    color: $verde-0;
  }
}
.percentage-stonks-negative {
  .icon-container {
    background: $vermelho-0;
  }
  .percentage {
    color: $vermelho-0;
  }
  .percentage-text {
    margin-right: 4px;
    color: $vermelho-d20;
  }
}
.set-weight {
  font-weight: 700;
}
</style>
